import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';
import { ForgotPasswordCredentials } from '@pages/login-recovery-options/models/forgot-password-credentials.interface';
import { TableTooltipComponent } from '@design/table/components/table-tooltip/table-tooltip.component';

@Component({
  selector: 'itc-recover-password-email-sent',
  templateUrl: 'recover-password-email-sent.component.html',
  styleUrl: 'recover-password-email-sent.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, TableTooltipComponent],
})
export class RecoverPasswordEmailSentComponent {
  private readonly loginRecoveryFacade = inject(LoginRecoveryFacade);

  readonly passwordRecoveryCredentials = computed(() => this.loginRecoveryFacade.recoveryCredentials() as ForgotPasswordCredentials);
}
